import { Button, FormLabel, Radio, RadioGroup, Text, VStack } from "@chakra-ui/react";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { connect, useSelector } from "react-redux";

import { RanaModal } from "@nens/ranalib";

import { AppDispatch } from "../App";
import { checkPermission } from "../state/appState";
import { inactivateModal } from "../state/mainGui";
import { getRateLimiterOn, setRateLimiterOnOff } from "../state/simulation";
import { formattedMessageForErrorCode } from "../utils/authorizationUtils";

const Preferences: React.FC<Props> = (props) => {
  const intl = useIntl();

  const globalRateLimiter = useSelector(getRateLimiterOn);
  const [localRateLimiter, setLocalRateLimiter] = useState(globalRateLimiter);

  const startStopAllowed = useSelector(checkPermission)("startStopSimulation");

  return (
    <RanaModal
      isOpen={true}
      onClose={props.inactivateModal}
      topBar={
        <FormattedMessage
          id="preferences_modal.title_calculation_speed"
          defaultMessage="Calculation speed"
        />
      }
      buttons={[
        <Button variant="secondary" onClick={props.inactivateModal}>
          <FormattedMessage id="preferences_modal.cancel_button" defaultMessage="Cancel" />
        </Button>,
        <Button
          variant="primary"
          onClick={() => {
            // save local data to redux store
            props.setRateLimiterOnOff(localRateLimiter);
            // close modal
            props.inactivateModal();
          }}
        >
          <FormattedMessage id="preferences_modal.button_save_settings" defaultMessage="Save" />
        </Button>,
      ]}
    >
      <Text maxW="420px" mb="16px">
        <FormattedMessage
          id="preferences_modal.explanation_content"
          defaultMessage="Some simulations can be too fast to follow in Rana LIVE. In those cases, choose the 'Capped speed' option to slow down the simulation."
        />
        {startStopAllowed.allowed
          ? null
          : formattedMessageForErrorCode(startStopAllowed.errorCode, intl)}
      </Text>
      <RadioGroup>
        <VStack maxW="420px" gap="4px" alignItems="start">
          <Radio isChecked={localRateLimiter} onChange={() => setLocalRateLimiter(true)}>
            <FormLabel as="strong">
              <FormattedMessage
                id="preferences_modal.radio_button_on_capped_speed"
                defaultMessage="Capped speed"
              />
            </FormLabel>
          </Radio>
          <Radio isChecked={!localRateLimiter} onChange={() => setLocalRateLimiter(false)}>
            <FormLabel as="strong">
              <FormattedMessage
                id="preferences_modal.radio_button_full_speed"
                defaultMessage="Full speed"
              />
            </FormLabel>
          </Radio>
        </VStack>
      </RadioGroup>
    </RanaModal>
  );
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    inactivateModal: () => dispatch(inactivateModal()),
    setRateLimiterOnOff: (turnOn: boolean) => dispatch(setRateLimiterOnOff(turnOn)),
  };
};
type Props = ReturnType<typeof mapDispatchToProps>;

export default connect(null, mapDispatchToProps)(Preferences);
